import { render, staticRenderFns } from "./CreateDocument.vue?vue&type=template&id=f320988e"
import script from "./CreateDocument.vue?vue&type=script&lang=js"
export * from "./CreateDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports